import { theme as defaultTheme } from "@mindlercare/ui-web";
import Tooltip from "@mui/material/Tooltip";
import { Typography } from "components/typography";
import { Slot } from "core/types/index";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { useTranslation } from "react-i18next";

type PaymentInfoProps = {
  slot: Slot;
  closeDialogWithHistory: () => void;
};

export const PaymentInfo = ({
  slot,
  closeDialogWithHistory,
}: PaymentInfoProps) => {
  const { t } = useTranslation();

  const isB2I = slot.promoCategory === "B2B_MEMBERSHIP";
  const isD2C = slot.promoCategory === "BUNDLE";
  const isB2B = slot.promoCategory === "B2B";

  if (!isB2I && !isD2C && !isB2B) {
    return null;
  }

  let patientType;
  let pillColor = "";
  if (isB2I) {
    patientType = "B2I";
    pillColor = defaultTheme.COLORS.PRIMARY_X_LIGHT;
  } else if (isD2C) {
    patientType = "D2C";
    pillColor = defaultTheme.COLORS.SECONDARY_LIGHT;
  } else if (isB2B) {
    patientType = "B2B";
    pillColor = defaultTheme.COLORS.TERTIARY_GREEN;
  }

  const isCompanyWithTranslations =
    slot.companyName === "dss" || slot.companyName === "seb";

  const title =
    isCompanyWithTranslations && slot.b2bMembershipPlanName
      ? t(slot.b2bMembershipPlanName)
      : slot.companyName;

  return (
    <Tooltip title={title} placement="top-end">
      <PaymentInfoPill
        pillColor={pillColor}
        to={`/patients/psychologist/${slot.psychologistId}/patient/${slot.userId}/promocodes`}
        onClick={closeDialogWithHistory}
      >
        <Typography variant="body-bold">{patientType}</Typography>
        &nbsp;
        <TypographyWithEllipsis variant="body">{title}</TypographyWithEllipsis>
        &nbsp;
        <Typography
          insensitive
          variant="body"
        >{`${slot.promoUsed}/${slot.promoTotal}`}</Typography>
      </PaymentInfoPill>
    </Tooltip>
  );
};

const PaymentInfoPill = styled(Link)<{ pillColor: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  margin: 0 16px;
  height: 36px;
  max-width: 250px;
  text-decoration: none;
  border-radius: 70px;
  background: ${({ pillColor }) => pillColor};
`;

const TypographyWithEllipsis = styled(Typography)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
